<template>
  <Loader v-if="isLoading"></Loader>
  <b-row v-else>
    <b-col lg="8" sm="12">
      <b-card>
        <b-col>
          <daily-plan :dailyPlanItems="dailyPlanItems" :serviceman="serviceman" @showMap="showMap()"></daily-plan>
        </b-col>
        <div class="btn-group">
          <button v-if="!isConfirmed" type="button" class="btn btn-sm btn-success fa fa-check fa-lg" @click="confirmDailyPlan()" v-b-tooltip.hover :title="$t('views.excmdailyplan.create.confirmPlan')"></button>
          <button v-if="!isConfirmed"  type="button" class="btn btn-sm fa fa-redo fa-lg" @click="restartDailyPlan()" v-b-tooltip.hover :title="$t('views.excmdailyplan.create.restartPlan')"></button>
          <button v-if="isConfirmed && !isFinished" type="button" class="btn btn-sm btn-warning fa fa-check fa-lg" @click="finishDailyPlan()" v-b-tooltip.hover :title="$t('views.excmdailyplan.create.finishPlan')"></button>
        </div>
      </b-card>
      <b-card v-if="Object.keys(hints).length > 0">
        <div class="mb-2">
          <span class="h6">{{$t('views.dailyPlan.show.plannedRoute')}}</span>
          <span class="ml-2">{{$t('views.dailyPlan.show.totalDistance')}}: {{roundDistance(hints.totalDistance / 1000)}} km</span>
          <hr class="mb-1 mt-1">
        </div>
        <table class="table table-sm table-grid">
          <thead>
          <tr>
            <th>{{$t('views.dailyPlan.show.legDistance')}}</th>
            <th>{{$t('global.from')}}</th>
            <th>{{$t('global.to')}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in hints.legs" :key="index">
            <td>{{roundDistance(item.distance/1000)}} km</td>
            <td>{{item.from}}</td>
            <td>{{item.to}}</td>
          </tr>
          </tbody>
        </table>
      </b-card>
      <b-card>
        <div class="mb-2">
          <span class="h6">{{$t('views.dailyPlan.show.cars')}}</span>
          <hr class="mb-1 mt-1">
        </div>
        <ServicemanCars :date="dailyPlanDate" :serviceman="serviceman"></ServicemanCars>
      </b-card>
    </b-col>
    <b-col lg="4" sm="12">
      <item-daily-plan-list
        @update="getDailPlanItems(dailyPlanSearchParams)"
        :dailyPlanItems="dailyPlanItems"
      ></item-daily-plan-list>
    </b-col>
    <b-col cols="12">
      <DailyPlanItemsMap
        v-if="!isLoading"
        @routeRetrieved="setRoute($event)"
        :initial-daily-plan-items="dailyPlanItems"
        ref="map"></DailyPlanItemsMap>
    </b-col>
    <DailyPlanMoveModal></DailyPlanMoveModal>
    <DailyPlanHoldModal></DailyPlanHoldModal>
    <CreateEXCMTaskModal></CreateEXCMTaskModal>
    <DailyPlanRedirectionModal></DailyPlanRedirectionModal>
  </b-row>
</template>

<script>
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import ItemDailyPlanList from './components/ItemDailyPlan/ItemDailyPlanList'
import getId from '@/utils/getIdFromLink'
import CreateEXCMTaskModal from '../excmtask/components/CreateEXCMTaskModal'
import DailyPlanRedirectionModal from './components/DailyPlanRedirectionModal/DailyPlanRedirectionModal'
import Loader from '../../Layout/Loader'
import DailyPlanHoldModal from './components/DailyPlanHoldModal/DailyPlanHoldModal'
import DailyPlanMoveModal from './components/DailyPlanMoveModal/DailyPlanMoveModal'
import VueCookie from 'vue-cookie'
import DailyPlanItemsMap from './components/DailyPlanItemsMap/DailyPlanItemsMap'
import ApiService from '@/utils/ApiService'
import DailyPlan from '@/components/Dashboard/Views/DailyPlan/components/DailyPlan'
import ServicemanCars from '@/components/Dashboard/Views/userdata/component/ServicemanCars/ServicemanCars'

export default {
  components: {
    ServicemanCars,
    DailyPlan,
    DailyPlanHoldModal,
    DailyPlanMoveModal,
    ItemDailyPlanList,
    CreateEXCMTaskModal,
    DailyPlanRedirectionModal,
    Loader,
    DailyPlanItemsMap
  },

  data () {
    return {
      isConfirmed: false,
      isFinished: false,
      dailyPlanItems: [],
      tabIndex: 0,
      prevRoute: null,
      isLoading: true,
      tasksQuantity: -1,
      dailyPlanDate: '',
      serviceman: {},
      item: {
        confirmed: 0,
        confirmedByUserData: null,
        settled: 0,
        settledByUserData: null
      },
      hints: {}
    }
  },
  computed: {
    dailyPlanSearchParams () {
      return {
        idUserData: this.idServiceman,
        date: this.dailyPlanDate
      }
    },
    idServiceman () {
      return parseInt(this.getIdLink(this.$route.params.idServiceman))
    },
    ableToEditTasks: function () {
      return this.checkRoles('tasks', 'EXCMTaskUpdate')
    },
    newTaskCreated: function () {
      return this.$store.state.modals.excmtask.create.created
    },
    dailyPlanItemHolded () {
      return this.$store.state.modals.dailyplan.hold.holded
    },
    dailyPlanItemMoved () {
      return this.$store.state.modals.dailyplan.move.moved
    },
    taskClosedManually () {
      return this.$store.state.modals.excmtask.closeManually.closed
    },
    abilityToChangeStatus: function () {
      let roles = VueCookie.get('roles')
      if (roles.includes('ROLE_SERVICEMAN') || roles.includes('ROLE_EXTERNAL_SERVICEMAN') || roles.includes('ROLE_SALES_REPRESENTATIVE')) {
        return false
      } else {
        return true
      }
    },
    mobileView () {
      return this.$store.state.mobileView
    }
  },

  watch: {
    $route () {
      this.isLoading = true
      this.createdFunctions()
    },
    newTaskCreated: function (val) {
      if (val === 1) {
        // this.getItemsDailyPlan()
        this.$store.state.modals.excmtask.create.created = 0
      }
    },
    dailyPlanItemHolded: function () {
      if (this.dailyPlanItemHolded === 1) {
        this.$store.state.modals.dailyplan.hold.holded = 0
        // this.getItemsDailyPlan()
      }
    },
    dailyPlanItemMoved: function () {
      if (this.dailyPlanItemMoved === 1) {
        this.$store.state.modals.dailyplan.move.moved = 0
        // this.getItemsDailyPlan()
      }
    },
    taskClosedManually: function () {
      if (this.taskClosedManually === 1) {
        this.$store.state.modals.excmtask.closeManually.closed = 0
        // this.getItemsDailyPlan()
      }
    },
    map: function () {
      // if (this.map) {
      //   this.addMarkersToMap()
      // }
    }
  },

  beforeCreate () {
    checkPagePermission('servicemen', 'DailyPlanShow')
  },

  created () {
    this.createdFunctions()
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_c_m_daily_plan_items_' + this.dailyPlanDate + '_' + this.getIdLink(this.$route.params.idServiceman))
    this.$store.state.picker.current = ''
  },

  methods: {
    roundDistance (distance) {
      return Math.round(distance * 100) / 100
    },
    setRoute (hints) {
      this.hints = hints
    },
    showMap () {
      this.$refs.map.$el.scrollIntoView()
    },
    createdFunctions () {
      this.isLoading = true
      this.dailyPlanDate = this.$route.params.date
      this.item.date = this.$moment().format('YYYY-MM-DD')
      this.getDailPlanItems(this.dailyPlanSearchParams)
      this.getServicemanData(this.idServiceman)
    },
    async getDailPlanItems (params) {
      this.dailyPlanItems = []
      const response = await new ApiService('e_x_c_m_daily_plan_items', params).getResults()
      this.dailyPlanItems = response.items
      if (this.dailyPlanItems && this.dailyPlanItems.length > 0) {
        this.isConfirmed = Boolean(this.dailyPlanItems[0].confirmed)
        this.isFinished = Boolean(this.dailyPlanItems[0].settled)
      }
    },
    async getServicemanData (id) {
      this.serviceman = await new ApiService(`user_datas/${id}`).getResults()
      this.isLoading = false
    },

    async finishDailyPlan () {
      const result = await this.showAlert('views.excmdailyplan.create.finishDailyPlanConfirmation')
      if (result && this.isConfirmed) {
        let data = {
          idUserData: this.idServiceman,
          date: this.$route.params.date
        }
        await new ApiService('e_x_c_m_daily_plan_items/settle').put(data)
        await this.getDailPlanItems(this.dailyPlanSearchParams)
      }
    },

    async confirmDailyPlan () {
      const result = await this.showAlert('views.excmdailyplan.create.confirmDailyPlanConfirmation')
      if (result && !this.isConfirmed) {
        let data = {
          idUserData: this.idServiceman,
          date: this.$route.params.date
        }
        await new ApiService('e_x_c_m_daily_plan_items/confirm').put(data)
        await this.getDailPlanItems(this.dailyPlanSearchParams)
      }
    },

    showAlert (title) {
      return this.$Swal({
        title: this.$t(title),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      })
    },

    async restartDailyPlan () {
      const result = await this.showAlert('views.excmdailyplan.create.restartDailyPlanConfirmation')
      if (result && !this.isConfirmed) {
        let data = {
          idUserData: this.idServiceman,
          date: this.$route.params.date
        }
        await new ApiService('e_x_c_m_daily_plan_items/reset').put(data)
        await this.getDailPlanItems(this.dailyPlanSearchParams)
      }
    },

    assignAll () {
      alert('brak obsługi (symfony)')
    },

    showRedirectionModal () {
      this.$store.state.modals.dailyplan.redirection.show = 1
      this.$store.state.modals.dailyplan.redirection.serviceman = this.serviceman
    },

    getIdLink (link) {
      return getId(link)
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    }
  }
}
</script>
